export enum DomainNames {
    IDENTIFICATION_TYPE = 'identificationtype'
}
